const menuToggleButton = document.querySelector('.menu-toggle');
const menuOverlay = document.querySelector('.menu-overlay');
const menuCloseButton = document.querySelector('.menu-overlay__close');

export const initMenuOverlay = () => {
  if (!menuToggleButton || !menuOverlay || !menuCloseButton) {
    return;
  }

  const transitionDurationMs = 220;
  let hideTimeoutId;

  const setExpandedState = (isExpanded) => {
    menuToggleButton.setAttribute('aria-expanded', String(isExpanded));
  };

  const openMenu = () => {
    window.clearTimeout(hideTimeoutId);
    menuOverlay.hidden = false;

    requestAnimationFrame(() => {
      menuOverlay.classList.add('is-open');
    });

    setExpandedState(true);
    document.body.classList.add('is-locked');

    const firstLink = menuOverlay.querySelector('a');
    if (firstLink) {
      firstLink.focus();
    }
  };

  const closeMenu = (restoreFocus = true) => {
    menuOverlay.classList.remove('is-open');
    setExpandedState(false);
    document.body.classList.remove('is-locked');

    hideTimeoutId = window.setTimeout(() => {
      menuOverlay.hidden = true;
    }, transitionDurationMs);

    if (restoreFocus) {
      menuToggleButton.focus();
    }
  };

  const toggleMenu = () => {
    if (menuOverlay.classList.contains('is-open')) {
      closeMenu();
      return;
    }

    openMenu();
  };

  menuToggleButton.addEventListener('click', toggleMenu);
  menuCloseButton.addEventListener('click', () => closeMenu());

  menuOverlay.addEventListener('click', (event) => {
    if (event.target === menuOverlay) {
      closeMenu();
    }
  });

  menuOverlay.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => closeMenu(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menuOverlay.classList.contains('is-open')) {
      closeMenu();
    }
  });
};
